<rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
<rr-card>
  <rr-card-content>
    <form
      class="registerform"
      [formGroup]="registerForm"
      (ngSubmit)="onSubmit()"
    >
      <div class="col headline">
        <h1 i18n>Sign up free</h1>
        <span i18n>No credit card required</span>
      </div>
      <rr-input
        label="Email"
        [required]="true"
        type="email"
        formControlName="email"
      ></rr-input>
      <rr-input
        label="Password"
        type="password"
        [required]="true"
        [verifyPassword]="true"
        formControlName="password"
      ></rr-input>

      <rr-btn type="Primary" (btnClick)="onSubmit()" i18n>Sign up</rr-btn>
      <div class="row gap-8 tiny">
        <span i18n>Already have an account?</span>
        <a i18n href="/login">Log in</a>
      </div>
    </form>
  </rr-card-content>
  <rr-card-footer>
    <span class="tiny" i18n
      >By signing up you agree to our
      <a href="/terms">terms of service</a></span
    >
    <span class="tiny" i18n
      >and have read the <a href="/privacy">privacy police</a></span
    >
  </rr-card-footer>
</rr-card>
<rr-spinner *ngIf="!hidespinner"></rr-spinner>
<input type="phone" name="phone" id="phone" [(ngModel)]="phone" />
